import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError, NetworkError } from "../api/problem";
import { setConnectionLost } from "./connectivity";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (e) => {
        if (e instanceof NetworkError) setConnectionLost(true);
      },
      onSuccess: () => setConnectionLost(false),
    }),
    mutationCache: new MutationCache({
      onError: (e) => {
        if (e instanceof NetworkError) setConnectionLost(true);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // A 4xx will not change on retry; a network error or a 5xx may.
        retry: (count, e) => !(e instanceof ApiError && e.status < 500) && count < 2,
      },
    },
  });
}
